import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { StandardReportingGuidelinesDisplay } from './StandardReportingGuidelinesDisplay';
import { FormFieldBoolean } from '.';
import { ISubmissionFile } from '@publishing-engine/domain/models';

interface Props {
  value: boolean;
  previousValue?: boolean | null;
  onClose: () => void;
  config: FormFieldBoolean;
  standardReportingGuidelinesDetails: string[] | undefined;
  CONSORTFiles: ISubmissionFile[] | undefined;
  ARRIVEFiles: ISubmissionFile[] | undefined;
  previousStandardReportingGuidelinesDetails: string[] | undefined;
  previousCONSORTFiles: ISubmissionFile[] | undefined;
  previousARRIVEFiles: ISubmissionFile[] | undefined;
  previousStandardReportingGuidelinesFileDetails: ISubmissionFile[] | undefined;
  StandardReportingGuidelinesFileDetails: ISubmissionFile[] | undefined;
  StandardReportingGuidelinesText?: string | undefined;
  previousStandardReportingGuidelinesText?: string | undefined;
}

export const StandardReportingGuidelinesDiffModal = ({
  value,
  previousValue,
  onClose,
  config,
  standardReportingGuidelinesDetails,
  CONSORTFiles,
  ARRIVEFiles,
  previousStandardReportingGuidelinesDetails,
  previousCONSORTFiles,
  previousARRIVEFiles,
  StandardReportingGuidelinesFileDetails,
  previousStandardReportingGuidelinesFileDetails,
  StandardReportingGuidelinesText,
  previousStandardReportingGuidelinesText
}: Props) => {
  const prevZeroState = typeof previousValue !== 'boolean';
  const currentZeroState = typeof value !== 'boolean';
  const labels = config.params.labels;
  const label = labels.main;

  const zeroState = (
    <Flex padding={2} backgroundColor="surfaceTertiaryFill">
      No {label} provided
    </Flex>
  );

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        {prevZeroState ? (
          zeroState
        ) : (
          <StandardReportingGuidelinesDisplay
            value={previousValue}
            subtitle={labels.options?.[previousValue.toString()]?.main}
            standardReportingGuidelinesDetails={
              previousStandardReportingGuidelinesDetails
            }
            CONSORTFiles={previousCONSORTFiles}
            ARRIVEFiles={previousARRIVEFiles}
            StandardReportingGuidelinesFileDetails={previousStandardReportingGuidelinesFileDetails}
            StandardReportingGuidelinesText={previousStandardReportingGuidelinesText}
          />
        )}
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        {currentZeroState ? (
          zeroState
        ) : (
          <StandardReportingGuidelinesDisplay
            value={value}
            subtitle={labels.options?.[value.toString()]?.main}
            standardReportingGuidelinesDetails={
              standardReportingGuidelinesDetails
            }
            CONSORTFiles={CONSORTFiles}
            ARRIVEFiles={ARRIVEFiles}
            StandardReportingGuidelinesFileDetails={StandardReportingGuidelinesFileDetails}
            StandardReportingGuidelinesText={StandardReportingGuidelinesText}
          />
        )}
      </DiffModal.RightSide>
    </DiffModal>
  );
};
